import { IconTableDashed } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import React from 'react';

function CostSharingComparison({ costSharing }) {
  const services = [
    { key: 'primary_care_physician', label: 'Primary Care Physician' },
    { key: 'specialist', label: 'Specialist' },
    { key: 'emergency_room', label: 'Emergency Room' },
    { key: 'inpatient_facility', label: 'Inpatient Facility' },
    { key: 'inpatient_physician', label: 'Inpatient Physician' },
    { key: 'generic_drugs', label: 'Generic Drugs' },
    { key: 'preferred_brand_drugs', label: 'Preferred Brand Drugs' },
    { key: 'non_preferred_brand_drugs', label: 'Non-Preferred Brand Drugs' },
    { key: 'specialty_drugs', label: 'Specialty Drugs' },
  ];

  // Function to safely get cost-sharing data with a fallback
  const getCostValue = (plan, key) => {
    return costSharing?.[plan]?.[key] ? costSharing[plan][key] : 'N/A';
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className="accordion-button text-capitalize"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#flush-collapse-cost-sharing-comparison"
          aria-expanded="true"
          aria-controls="flush-collapse-cost-sharing-comparison"
        >
          <IconTableDashed size={18} className="me-2 my-2" />
          Cost Sharing Comparison
        </button>
      </h2>
      <div
        id="flush-collapse-cost-sharing-comparison"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body">
          <div className="ps-table table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">SERVICE</th>
                  <th scope="col">COVERAGE DETAILS</th>
                  {/* <th scope="col">73% PLAN</th>
                  <th scope="col">87% PLAN</th>
                  <th scope="col">94% PLAN</th> */}
                </tr>
              </thead>
              <tbody>
                {services.map((service) => (
                  <tr key={service.key}>
                    <td>{service.label}</td>
                    <td>{getCostValue('standard', service.key)}</td>
                    {/* <td>{getCostValue('73_percent', service.key)}</td>
                    <td>{getCostValue('87_percent', service.key)}</td>
                    <td>{getCostValue('94_percent', service.key)}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

CostSharingComparison.propTypes = {
  costSharing: PropTypes.object.isRequired,
};
export default CostSharingComparison;
